import{useContext}from"react";import{UseCurrentTrialContext}from"../../contexts/use-current-trial.context.js";function useCurrentTrialContext(props){return useContext(UseCurrentTrialContext)(props)}export{useCurrentTrialContext};
